if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector('.pg-dots'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // Initialisiere Dots-Navigation
        this.initializeDots();
        
        // FIX: Slider Buttons mit Timing-Fix
        this.initializeSliderButtons();
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      // Neue Methode für Slider Button Fix
      initializeSliderButtons() {
        const prevButtons = this.querySelectorAll('.slider-button--prev');
        const nextButtons = this.querySelectorAll('.slider-button--next');
        
        prevButtons.forEach(button => {
          // Clone button to remove existing event listeners
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
          
          newButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Force reflow
            this.elements.viewer.offsetHeight;
            
            requestAnimationFrame(() => {
              const currentActive = this.elements.viewer.querySelector('.product__media-item.is-active');
              const prevItem = this.getPreviousMediaItem(currentActive);
              
              if (prevItem) {
                const mediaId = prevItem.dataset.mediaId;
                this.setActiveMedia(mediaId, false);
              }
            });
          });
        });
        
        nextButtons.forEach(button => {
          // Clone button to remove existing event listeners
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
          
          newButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Force reflow
            this.elements.viewer.offsetHeight;
            
            requestAnimationFrame(() => {
              const currentActive = this.elements.viewer.querySelector('.product__media-item.is-active');
              const nextItem = this.getNextMediaItem(currentActive);
              
              if (nextItem) {
                const mediaId = nextItem.dataset.mediaId;
                this.setActiveMedia(mediaId, false);
              }
            });
          });
        });
      }

      // Helper: Vorheriges Media Item finden
      getPreviousMediaItem(currentItem) {
        if (!currentItem) return null;
        
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
        const currentIndex = mediaItems.indexOf(currentItem);
        
        if (currentIndex > 0) {
          return mediaItems[currentIndex - 1];
        } else {
          // Loop to last item
          return mediaItems[mediaItems.length - 1];
        }
      }

      // Helper: Nächstes Media Item finden
      getNextMediaItem(currentItem) {
        if (!currentItem) return null;
        
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
        const currentIndex = mediaItems.indexOf(currentItem);
        
        if (currentIndex < mediaItems.length - 1) {
          return mediaItems[currentIndex + 1];
        } else {
          // Loop to first item
          return mediaItems[0];
        }
      }

      // Dots-Initialisierung (Event Delegation Version)
      initializeDots() {
        if (!this.elements.dots) return;
        
        const mediaItems = this.elements.viewer.querySelectorAll('.product__media-item');
        if (mediaItems.length <= 1) return;

        // Leere bestehende Dots
        this.elements.dots.innerHTML = '';
        
        // Erstelle Dots für jedes Media Item
        mediaItems.forEach((mediaItem, index) => {
          const dot = document.createElement('button');
          dot.className = `pg-dot ${mediaItem.classList.contains('is-active') ? 'is-active' : ''}`;
          dot.setAttribute('data-media-id', mediaItem.dataset.mediaId);
          dot.setAttribute('data-index', index);
          dot.setAttribute('aria-label', `Gehe zu Bild ${index + 1}`);
          dot.setAttribute('type', 'button');

          this.elements.dots.appendChild(dot);
        });

        // Einmaliger Event Listener auf dem Container (Event Delegation)
        this.elements.dots.addEventListener('click', (event) => {
          if (event.target.classList.contains('pg-dot')) {
            const mediaId = event.target.getAttribute('data-media-id');
            this.setActiveMedia(mediaId, false);
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        
        // Update Dots bei Slide-Änderung
        this.updateActiveDot(event.detail.currentElement.dataset.mediaId);
      }

      setActiveMedia(mediaId, prepend) {
        // Verwende spezifischeren Selektor, um Dots auszuschließen
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"].product__media-item`) ||
          this.elements.viewer.querySelector('.product__media-item[data-media-id]');
          
        if (!activeMedia) {
          return;
        }
        
        // Entferne aktive Klasse nur von Media-Items, nicht von Dots
        this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        
        activeMedia.classList.add('is-active');

        // Force DOM reflow/repaint
        activeMedia.offsetHeight;

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        
        // Update Dots SOFORT
        this.updateActiveDot(mediaId);
        
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // Update Dots Methode
      updateActiveDot(activeMediaId) {
        if (!this.elements.dots) return;
        
        const dots = this.elements.dots.querySelectorAll('.pg-dot');
        dots.forEach(dot => {
          const isActive = dot.dataset.mediaId === activeMediaId;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}